<template>
  <div>
    <el-button type="text" @click="dialogVisible = true">{{ info.description }}</el-button>
    <el-dialog title="详细" :visible.sync="dialogVisible" :append-to-body="true">
      <el-form>
        <el-form-item label="考核标准:">{{
          info.itemDesc + info.relation + relationValue + '     达标'
        }}</el-form-item>
        <el-form-item label="绩效结果:">{{ result }}</el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const formatKpiData = (row) => {
  const val = row.item === 1 ? row.relationValue / 100 : row.relationValue / 100 + '%'
  return val
}
export default {
  name: 'detail-info',
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialogVisible: false,
    }
  },
  computed: {
    relationValue() {
      return formatKpiData(this.info)
    },
    realValue() {
      return this.info.item === 1 ? this.info.realValue / 100 : this.info.realValue / 100 + '%'
    },
    result() {
      if (this.info.realValue === null) {
        return '未获取到统计数据'
      }
      return this.info.itemDesc + '   ' + this.realValue + '    ' + this.info.description
    },
  },
}
</script>
